/**
 * Whether the persona-location filter offers a real choice.
 *
 * The dashboard location filter only lets the user filter when there are at
 * least two locations to pick between. With zero or one location there is
 * nothing to filter, so cards use this to hide the "FILTERS" toggle entirely
 * (an empty/expand-to-nothing filter bar reads as a bug to users).
 *
 * @param {Array<object>} [locations] - The tenant's Locations collection (may be undefined while loading).
 * @returns {boolean}
 */
const hasLocationFilter = (locations) =>
    Array.isArray(locations) && locations.length >= 2;

export default hasLocationFilter;
